(function () {
  'use strict';

  angular.module('app').component('bookingInvoiceStatusLabel', bookingInvoiceStatusLabel());

  function bookingInvoiceStatusLabel() {
    return {
      bindings: {
        status: '<',
      },
      controller: BookingInvoiceStatusLabelComponent,
      controllerAs: 'vm',
      template:
        '<span class="status-label text-{{ vm.statusClass }}">' +
        '<i class="fa fa-circle"></i> {{ vm.statusTitle }}' +
        '</span>',
    };
  }

  BookingInvoiceStatusLabelComponent.$inject = ['$translate'];

  function BookingInvoiceStatusLabelComponent($translate) {
    const vm = this;

    vm.$onChanges = function () {
      setStatusLabel();
    };

    function setStatusLabel() {
      let statusClass;
      let statusIcon;
      let statusTitle;

      switch (vm.status) {
        case 'partially':
          statusClass = 'warning';
          statusTitle = 'PARTIALLY_INVOICED';
          statusIcon = 'spinner';
          break;
        case 'invoiced':
          statusClass = 'success';
          statusTitle = 'FULLY_INVOICED';
          statusIcon = 'check';
          break;
        default:
          statusClass = 'default';
          statusTitle = 'NO_INVOICED';
          statusIcon = 'minus';
          break;
      }

      vm.statusClass = statusClass;
      vm.statusIcon = statusIcon;
      vm.statusTitle = $translate.instant(statusTitle);
    }
  }
})();
